import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgot_password, messageClear } from "../store/reducers/authReducer";
import toast from "react-hot-toast";
import FadeLoader from "react-spinners/FadeLoader";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { LanguageContext } from "../context/LanguageContext";

const ForgotPassword = () => {
  const { t } = useContext(LanguageContext);
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loader, successMessage, errorMessage } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage || t("resetLinkSent"));
      dispatch(messageClear());
      navigate("/login");
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch, navigate, t]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      toast.error(t("pleaseEnterEmail"));
      return;
    }
    dispatch(forgot_password(email));
  };

  return (
    <div>
      {loader && (
        <div className="fixed inset-0 z-[999] bg-[#38303033] flex items-center justify-center">
          <FadeLoader />
        </div>
      )}
      <Headers />
      <div className="bg-slate-200 mt-4">
        <div className="max-w-[1440px] mx-auto px-6 py-10">
          <div className="bg-white shadow-md rounded-lg mx-auto w-[60%] md:w-full p-8">
            <h2 className="text-xl font-bold text-center text-slate-600 mb-6">
              {t("forgotPassword")}
            </h2>

            <form
              onSubmit={handleSubmit}
              className="text-slate-600 max-w-md mx-auto"
            >
              <div className="mb-4">
                <label htmlFor="email">{t("emailLabel")}</label>
                <input
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  type="email"
                  name="email"
                  id="email"
                  placeholder={t("emailPlaceholder")}
                  className="w-full mt-1 px-3 py-2 border border-slate-200 rounded-md outline-none focus:border-purple-500"
                  required
                />
              </div>

              <div className="flex items-center justify-between">
                <Link
                  to="/login"
                  className="text-sm text-purple-500 hover:underline"
                >
                  {t("login")}
                </Link>
                <button
                  type="submit"
                  className="py-2 px-4 bg-purple-500 text-white rounded-md hover:bg-purple-600 transition"
                  disabled={loader}
                >
                  {loader ? t("processing") : t("sendResetLink")}
                </button>
              </div>
            </form>

            <p className="mt-4 text-center text-sm text-slate-500">
              {t("dontHaveAccount")}{" "}
              <Link className="text-blue-500" to="/register">
                {t("register")}
              </Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
